import * as XLSX from "xlsx";
export class exportExcel {
  exportTable(obj: any, data: any[], name: string) {
    let xlsArr = [];
    xlsArr.push(Object.keys(obj).map(key => `${obj[key]}`));
    data.forEach(item => {
      xlsArr.push(Object.keys(obj).map(key => `${item[key]}`));
    });
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(xlsArr);
    const ws2: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(xlsArr);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${name}.xlsx`);
  }
}